import * as React from 'react';
import { Progress, Table, Button } from 'reactstrap';
import { BarcodeScannerHandler } from '../../../../../Services/BarcodeScannerHandler';
import { PackIdentifier, IPackIdentifier } from '../../../../../Types/PackIdentifier';
import { EventHandlerProvider } from '../../../../../Services';
import { VeriLiteWarningEvent, IResources } from '../../../../../Types';
import * as SignalR from "@microsoft/signalr";
import { postJson, UserRequestHeaders } from '../../../../../Services/Util';
import { Auth } from '../../../../../Services/AuthenticationService';
import '../Styles/ScanArea.css';

interface IScanAreaProps {
    maxNumberofPacks: number;
    scannedPacks: PackIdentifier[];
    addPack: (pack: PackIdentifier) => void;
    removePack: (pack: PackIdentifier) => void;
    connectionState: SignalR.HubConnectionState;
    calibrationData: any;
    setAlert: (key: string) => void;
    resources: IResources;
}

interface IScanAreaState {

}

export class ScanArea extends React.Component<IScanAreaProps, IScanAreaState>{
    constructor(props: IScanAreaProps) {
        super(props);
        this.state = {};

        this.barcodeScannerHandler = new BarcodeScannerHandler(this.onScan.bind(this));
        document.addEventListener("keypress",
            this.barcodeScannerHandler.keyPressHandler,
            true);

        document.addEventListener("keydown",
            this.barcodeScannerHandler.keyDownHandler,
            true);

        document.addEventListener("keyup",
            this.barcodeScannerHandler.keyUpHandler,
            true);

        this.tableRef = React.createRef();
    }

    componentWillUnmount() {
        document.removeEventListener("keypress",
            this.barcodeScannerHandler.keyPressHandler,
            true);

        document.removeEventListener("keydown",
            this.barcodeScannerHandler.keyDownHandler,
            true);

        document.removeEventListener("keyup",
            this.barcodeScannerHandler.keyUpHandler,
            true);
    }

    barcodeScannerHandler: BarcodeScannerHandler;
    tableRef: any;

    onScan(dom3KeyboardEventCodeSupport: any) {

        if (this.props.connectionState != SignalR.HubConnectionState.Connected) {
            EventHandlerProvider.GetInstance().AddEvent(new VeriLiteWarningEvent(this.props.resources.VeriLiteDisconnected));
            return;
        }

        if (this.props.scannedPacks.length >= this.props.maxNumberofPacks) {
            this.props.setAlert("Error_MaxBulkRequestSizeExceeded");
            return;
        }
        let scannedData = dom3KeyboardEventCodeSupport ?
            this.barcodeScannerHandler.scannerInput.getInput() :
            this.barcodeScannerHandler.scannerInput.getInputBytes();
        let scannedString = String.fromCharCode(...scannedData);

        if (scannedData.length > 20) {
            const json = JSON.stringify({ ScannedData: scannedString, CalibrationData: this.props.calibrationData });
            const headers = new UserRequestHeaders({ Organisation: Auth.getUser().Organisation, Location: Auth.getUser().Location, id: Auth.getUser().id });
            postJson(`/Parser/Parse`, json, undefined, undefined, headers)
                .then((pack: PackIdentifier) => {
                    var newPack = new PackIdentifier(pack);
                    if (newPack.submit) {
                        if (this.props.scannedPacks.some((pack: PackIdentifier) => (pack.key() == newPack.key()))) {
                            this.props.setAlert("InvalidBulkRequest_DuplicatesNotAllowed");
                        }
                        else {
                            this.props.addPack(newPack);
                            this.tableRef.current.scrollTop = this.tableRef.current.scrollHeight;
                        }
                    }
                    else {
                        this.props.setAlert("CannotParseBarcode");
                    }
                });
        }
    }

    render() {
        return (
            <>
                <Progress value={this.props.scannedPacks.length} max={this.props.maxNumberofPacks}>{this.props.scannedPacks.length}/{this.props.maxNumberofPacks}</Progress>
                <div className="scan-area-table-container" ref={this.tableRef}>
                    <Table striped size="sm">
                        <thead>
                            <tr>
                                <th>{this.props.resources.ProductCode}</th>
                                <th>{this.props.resources.SerialNumber}</th>
                                <th>{this.props.resources.BatchID}</th>
                                <th>{this.props.resources.ExpiryDate}</th>
                                <th> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.scannedPacks.map((pack) =>
                                <tr key={pack.key()}>
                                    <td>{pack.productCode}</td>
                                    <td>{pack.serialNumber}</td>
                                    <td>{pack.batchIdentifier}</td>
                                    <td>{pack.getFormatExpiryDate()}</td>
                                    <td> <Button close onClick={() => {
                                        this.props.removePack(pack);
                                    }} /></td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </>
        );
    }
}